module.exports = __webpack_public_path__ + "media/images/logo-otec-manager-blanco-0360f02c42ea5344ba1925eb1c37c97b.svg";